// Defaults
export const defaultErrorMessage = "Something went wrong. Please try again."

export const customErrorWithAction = (action, itemType = "item", name) =>
    `Something went wrong while ${action} ${
        name ? `"${name}"` : `the ${itemType}`
    }. Please try again.`

// Loading messages
export const loadingErrorMessage = (itemType, name) =>
    customErrorWithAction("loading", itemType, name)
export const analysingErrorMessage = (itemType, name) =>
    customErrorWithAction("analyzing", itemType, name)

// Saving messages
export const saveSuccessMessage = name =>
    (name ? `${name} has ` : "Your changes have ") + "been saved."
export const saveErrorMessage = (itemType, name) =>
    customErrorWithAction("saving", itemType, name)
export const createSuccessMessage = (name = "The item") =>
    `${name} has been created.`

// Deleting messages
export const deleteSuccessMessage = (name = "The item") =>
    `${name} has been deleted.`
export const deleteErrorMessage = (itemType, name) =>
    customErrorWithAction("deleting", itemType, name)

// Cancelling message
export const cancelChangesMessage = (name = "the item") =>
    `Your changes to ${name} have been cancelled.`

// Invalidation messages
export const missingFieldMessage = fieldName => `Please enter a ${fieldName}.`
export const overallInvalidInputMessage =
    "You input is not valid. Please check it and try again."

// Feature in development (otherwise known as "Warding off Jim" ;) )
export const toBeImplementedMessage = (featureName = "This feature") =>
    `${featureName} is in progress! Please wait for when it will be completed.`

// Info messages
export const briefingGenerationMessage = "Creating briefing. Please wait."
export const imageGenerationMessage = "Exporting image. Please wait."
